export const dealPipelineTableColumns = [
  { title: 'Strategy', key: 'DEAL', width: 400, keySort: 'strategy', cellKey: 'name', isHidden: false, order: 0, isFixed: true },
  { title: 'Manager', key: 'MANAGER', width: 300, keySort: 'manager', cellKey: 'manager', isHidden: false, order: 1 },
  { title: 'Asset Class', key: 'ASSET_CLASS', width: 300, keySort: 'asset class', cellKey: 'assetClass', isHidden: false, order: 2 },
  { title: 'Pacing Type', key: 'PACING_TYPE', width: 200, keySort: 'pacing type', cellKey: 'pacingType', isHidden: false, order: 3 },
  { title: 'Vintage', key: 'VINTAGE', width: 200, keySort: 'vintage', cellKey: 'vintage', isHidden: false, order: 4 },
  {
    title: 'Investor Docs Due',
    key: 'INVESTOR_DOCS_DUE',
    width: 200,
    keySort: 'investor docs due',
    cellKey: 'investorDocsDue',
    isHidden: false,
    order: 5
  },
  { title: 'Next Close', key: 'NEXT_CLOSE', width: 200, keySort: 'next close', cellKey: 'nextClose', isHidden: false, order: 6 },
  { title: 'Final Close', key: 'FINAL_CLOSE', width: 200, keySort: 'final close', cellKey: 'finalClose', isHidden: false, order: 7 },
  { title: 'Minimum', key: 'MINIMUM', width: 200, keySort: 'minimum', cellKey: 'minimum', isHidden: false, order: 8 },
  { title: 'Custodied', key: 'CUSTODIED', width: 200, keySort: 'custodied', cellKey: 'custodied', isHidden: false, order: 9 },
  {
    title: 'Tax Exempt Suitable',
    key: 'UBTI_BLOCKER',
    width: 200,
    keySort: 'tax exempt suitable',
    cellKey: 'ubtiBlocker',
    isHidden: false,
    order: 10
  },
  { title: 'SRI', key: 'SRI', width: 200, keySort: 'sri', cellKey: 'sri', isHidden: false, order: 11 },
  { title: 'Target IRR', key: 'TARGET_IRR', width: 200, keySort: 'target IRR', cellKey: 'targetIrr', isHidden: false, order: 12 },
  { title: 'Target Yield', key: 'TARGET_YIELD', width: 200, keySort: 'target yield', cellKey: 'targetYield', isHidden: false, order: 13 },
  {
    title: 'Aggregate Interest',
    key: 'AGGREGATE_INTEREST',
    width: 200,
    keySort: 'aggregate interest',
    cellKey: 'aggregateInterest',
    isHidden: false,
    order: 14
  },
  {
    title: 'Aggregate Commitment',
    key: 'AGGREGATE_COMMITMENT',
    width: 200,
    keySort: 'aggregate commitment',
    cellKey: 'aggregateCommitment',
    isHidden: false,
    order: 15
  },
  { title: 'Assignee', key: 'ASSIGNEE', width: 200, keySort: 'assignee', cellKey: 'assignee', isHidden: false, order: 16 },
  { title: 'Last Update', key: 'LAST_UPDATED', width: 200, keySort: 'last update', cellKey: 'lastUpdate', isHidden: false, order: 17 },
  { title: 'Status', key: 'NEXT_TASK', width: 200, keySort: 'status', cellKey: 'status', isHidden: false, order: 18 },
  { title: 'Due Diligence', key: null, width: 200, keySort: 'due diligence', cellKey: 'dueDiligence', isHidden: false, order: 19 },
  {
    title: 'Advisor restrictions',
    key: 'ADVISOR_RESTRICTIONS',
    width: 200,
    keySort: 'advisor restrictions',
    cellKey: 'advisorRestrictions',
    isHidden: false,
    order: 20
  }
];

export const dealPipelineSelectors = [
  { key: 'ALL', value: 'All Assignees' },
  { key: 'ASSIGN_TO_ME', value: 'Assigned To Me' },
  { key: 'OWNED_BY_ME', value: 'Owned By Me' },
  { key: 'OWNED_BUT_ASSIGNED_TO_OTHER', value: 'Owned By Me Assigned To Someone Else' }
];

export const dealPipelineMobileSort = [
  {
    title: 'Strategy • A -> Z',
    key: 'DEAL',
    asc: true
  },
  {
    title: 'Strategy • Z -> A',
    key: 'DEAL',
    asc: false
  },
  {
    title: 'Manager • A -> Z',
    key: 'MANAGER',
    asc: true
  },
  {
    title: 'Manager • Z -> A',
    key: 'MANAGER',
    asc: false
  },
  {
    title: 'Aggregate Interest • Max -> Min',
    key: 'AGGREGATE_INTEREST',
    asc: false
  },
  {
    title: 'Aggregate Interest • Min -> Max',
    key: 'AGGREGATE_INTEREST',
    asc: true
  },
  {
    title: 'Aggregate Commitment • Max -> Min',
    key: 'AGGREGATE_COMMITMENT',
    asc: false
  },
  {
    title: 'Aggregate Commitment • Min -> Max',
    key: 'AGGREGATE_COMMITMENT',
    asc: true
  },
  {
    title: 'Close Date • Sooner -> Later',
    key: 'CLOSE_DATE',
    asc: true
  },
  {
    title: 'Close Date  • Later -> Sooner',
    key: 'CLOSE_DATE',
    asc: false
  },
  {
    title: 'Assignee • A -> Z',
    key: 'ASSIGNEE',
    asc: true
  },
  {
    title: 'Assignee • Z -> A',
    key: 'ASSIGNEE',
    asc: false
  },
  {
    title: 'Last Update • Newest -> Oldest',
    key: 'LAST_UPDATED',
    asc: false
  },
  {
    title: 'Last Update • Oldest -> Newest',
    key: 'LAST_UPDATED',
    asc: true
  },
  {
    title: 'Status • A -> Z',
    key: 'NEXT_TASK',
    asc: false
  },
  {
    title: 'Status • Z -> A',
    key: 'NEXT_TASK',
    asc: true
  }
];
